(function() {
    let tlFreeGiftOfferClone;

    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() { return tlFreeGiftOfferClone; },
        set(val) {
            if (!val || tlFreeGiftOfferClone) return;
            tlFreeGiftOfferClone = val;

            val.refreshCartContent = async function() {
                const isCartPage = window.location.pathname === "/cart";
                const refresh = window.tlGetRefreshCartFunc 
                    ? window.tlGetRefreshCartFunc(async () => {
                        await this.updateCartData();
                        window.tlCartGoalEmbed?.updateCartTotal();
                    })
                    : () => window.location.reload();
                isCartPage ? await refresh() : window.location.reload();
            };
        },
        configurable: true
    });
})();